module.exports = __webpack_public_path__ + "static/media/icon-refresh.dc651a4e.svg";